import { QuickLinks, Types } from '.'
import { EJ } from '../../../constants/CIMSModule/instances'
import { CIMSPageItem } from '../CIMSPageItem'

export const EJLog = new CIMSPageItem({
  id: '603f6d4d-5447-4d5f-b3fa-cfe2ae97ac5e',
  name: 'EJ Log',
  pathname: 'log',
  module: EJ,
  linkable: true,
})

export const EJTypes = Types({
  id: '88ff8c61-01f0-4cef-8129-6969db8cde78',
  module: EJ,
})

export const EJNotifications = new CIMSPageItem({
  id: 'd8ae855d-ae61-4f53-94d7-5fcd2266b585',
  name: 'Notifications',
  pathname: 'notifications',
  module: EJ,
})

export const EJQuickLinks = QuickLinks({
  id: '5de2c91f-d2f9-40a8-bfaf-a126526ca134',
  module: EJ,
})

export type EJPageItem =
  | typeof EJLog
  | typeof EJTypes
  | typeof EJNotifications
  | typeof EJQuickLinks
